<template>
<div class="list-group border-0 timeList latest-notice">
   <template v-for="(res, index) in notices">
      <div :key="index" class="list-start border-0 pr-3 pl-3 pt-0 list-group-item list-group-item-action flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <div class="mb-1 title">{{res.title}}</div>
        </div>
        <li v-for="(eachRes, looping) in res.content"
            :key="index+'-'+looping"
            class="border-0 w-100 p-0 pt-2 pb-2 list-group-item justify-content-between"
            gtm-on="click"
            gtm-event-action="Menu/Click"
            :gtm-event-label="`Menu/${eachRes.subTitle} (${res.title})`"
            >
          <div class="timeSlop">{{eachRes.subTitle}}</div>
          <div class="notice-number d-flex align-items-center rounded-circle" ><div class="mx-auto text-center">{{eachRes.number}}</div></div>
        </li>
      </div>
    </template>
  </div>
</template>
<script>
  export default{
    name: 'latest-notice',
    props: {
      notices: {
        type: Array,
        required: true,
        default: [],
      },
    },
  }
</script>
<style lang="scss" scoped>
.timeList{
  li{
      background:rgba(0,0,0,0.0);
  }
  .notice-number{
    width:rem-calc(24);
    height:rem-calc(24);
    background:$rose;
    color:$white;
    font-size:rem-calc(14);
  }
  font-family: $barlow;
  .list-start{
    .badge{
      font-family:$barlow;
      font-size:rem-calc(14);
      background:$rose;
    }
    .title{
      text-transform: uppercase;
      font-family: $barlow;
      font-weight:bold;
      font-size:rem-calc(12);
      color: $manatee;
    }
    .timeSlop{
      font-size:rem-calc(24);
      color: $white;
      font-weight:bold;
    }
    background:rgba(0,0,0,0.0);
  }
}

</style>



// WEBPACK FOOTER //
// LatestNotice.vue?22d1ee48